import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Pdf = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.6 18.4999V19.7C19.6 21.0254 18.5255 22.0999 17.2 22.0999L6.39999 22.0999C5.0745 22.0998 3.99999 21.0253 4 19.6998L4.00009 5.29989C4.0001 3.97441 5.07462 2.8999 6.40009 2.8999H17.2003C18.5258 2.8999 19.6003 3.97445 19.6003 5.29995V9.2999"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.8895 14.187V16.2998H6.9167V10.843H9.0979C10.3139 10.843 11.0739 11.413 11.0739 12.515C11.0739 13.6018 10.3139 14.187 9.0979 14.187H7.8895ZM7.8895 13.351H9.0447C9.7439 13.351 10.1163 13.047 10.1163 12.515C10.1163 11.9754 9.7439 11.679 9.0447 11.679H7.8895V13.351ZM11.8707 16.2998V10.843H13.6947C15.3895 10.843 16.4383 11.907 16.4383 13.5714C16.4383 15.2358 15.3895 16.2998 13.6947 16.2998H11.8707ZM12.8207 15.4638H13.6947C14.8195 15.4638 15.4807 14.719 15.4807 13.5714C15.4807 12.4162 14.8195 11.679 13.6871 11.679H12.8207V15.4638ZM18.3092 16.2998H17.3516V10.843H20.992V11.6942H18.3092V13.1762H20.5588V14.0274H18.3092V16.2998Z"
        fill={color}
      />
    </svg>
  )
})

export default Pdf
